exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hr-sect[data-v-1b85c70d] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-preferred-size: 100%;\r\n      flex-basis: 100%;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  margin: 8px 0px;\n}\n.hr-sect[data-v-1b85c70d]::before,\r\n.hr-sect[data-v-1b85c70d]::after {\r\n  content: \"\";\r\n  -webkit-box-flex: 1;\r\n      -ms-flex-positive: 1;\r\n          flex-grow: 1;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  height: 1px;\r\n  font-size: 0px;\r\n  line-height: 0px;\r\n  margin: 0px 8px;\n}\r\n\r\n", ""]);

// exports
